import UkraineMapPreview from '../images/maps/ukraine.webp';
import ExplosiveWeaponsPreview from '../images/maps/explosiveWeapons.webp';

export const otherMaps = [
    {
        id: 'ukraine',
        image: UkraineMapPreview,
        imageTitle: 'Ukraine Map Preview',
        header: 'Attacks on Health Care in Ukraine',
        description:
            "Documenting attacks on Ukraine's health care system resulting from Russia's invasion",
        url: 'https://www.attacksonhealthukraine.org/',
    },
    {
        id: 'explosiveWeaponsMonitor',
        image: ExplosiveWeaponsPreview,
        imageTitle: 'Explosive Weapons Monitor Preview',
        header: 'Explosive Weapons Monitor',
        description:
            'Tracking harm to civilians from the use of explosive weapons across the globe',
        url: 'https://explosiveweaponsmonitor.org/global-figures/',
    },
];
